import React from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { render } from 'react-dom';
import styled from 'styled-components';

import { BaseDialog } from './baseDialog';
import Modal from './modal';

export class Prompt extends BaseDialog<string> {
  value = '';

  handleChange = (e: any) => {
    this.value = e.target.value;
  };

  constructor(message: string, buttonText = 'OK', defaultValue = '', fieldProps?: any) {
    super();
    this.el = document.createElement('div');
    this.el.id = 'prompt';
    this.value = defaultValue;

    document.body.appendChild(this.el);

    render(
      <Modal isOpen onToggle={this.close} dialog data-test='prompt' contentLabel='Prompt dialog'>
        <Padded data-test="alert">
          <p data-test="modal-text">{message}</p>

          <FormControl defaultValue={defaultValue} onChange={this.handleChange} autoFocus type="text" {...fieldProps} />

          <br />

          <Button type="submit" onClick={this.confirm} data-accesskey="Enter">
            {buttonText}
          </Button>
        </Padded>
      </Modal>,
      this.el,
    );
  }

  confirm = (evt: any) => {
    evt.preventDefault();
    evt.stopPropagation();

    this.resolvePromise(this.value.trim());
    this.unmount();
  };
}

const Padded = styled.div`
  padding: 2em;
  padding-bottom: 1em;
  text-align: center;
  min-width: 20em;
`;
